import axios from 'axios'
import AuthService from '../services/AuthService';
import createAxiosInstance from '../interceptor/axiosInterceptor';
import appConfig from '@/config/appConfig';
const instance = createAxiosInstance(appConfig.VUE_APP_USERS_API_URL);

export default {
    getUserInfo: async function () {
        const userId = AuthService.getUserId()
        console.log("userId*****", userId)
        try {
            const response = await instance.get('/getUserInfo?userId=' + userId)
            return response;
        } catch (error) {
            return error.response;
        }
    },


    publishResult: async function () {
        try {
            const userId = AuthService.getUserId()
            const response = await instance.get('/publishResult?userId=' + userId,)
            return response;
        } catch (error) {
            return error.response;
        }
    },

    getUserInfoFromResume: async function (
        path,
        fileType
    ) {
        try {
            const userId = AuthService.getUserId()
            const response = await instance.post(
                "/resume/parse",
                {
                    userId,
                    path,
                    fileType
                });
            return response;
        } catch (error) {
            console.log(error.data);
        }
    },

    saveAssessmentAction: async function (userId,campaignId,action, assessmentStage) {
        try {
            const response = await instance.post(
                "/saveAssessmentAction",
                {
                    userId,
                    campaignId,
                    action,
                    assessmentStage
                });
            return response;
        } catch (error) {
            return error.response;
        }
    },

    getHRDetails: async function(schoolCode) {
        try {
            const response = await instance.get("/getHRDetails?schoolCode="+schoolCode);
            return response.data;
        } catch (error) {
            console.error("Error",error);
        }
    },

    doResetUserForNewCampaign: async function(campaignId) {
        try {
            const response = await instance.put("/resetUserForNewCampaign", { campaignId });
            return response.data;
        } catch (error) {
            console.error("Error resetting user for new campaign:", error);
            return error.response;
        }
    }


}
